<template>
  <div
    style="
      background: rgb(255, 255, 255);
      height: 100%;
      padding: 10px;
      box-sizing: border-box;
    "
  >
    <!-- <el-button
      icon="el-icon-circle-plus-outline"
      type="primary"
      style="margin-left:20px;"
      @click="addService"
    >新增服务</el-button>-->
    <el-button
      icon="el-icon-plus"
      type="primary"
      plain
      @click="addGood"
      >新增商品</el-button
    >
    <el-tag type="success" style="position: absolute; right: 30px"
      >商品总数:{{ total }}</el-tag
    >
    <el-row :gutter="60">
      <el-col
        :span="4"
        v-for="item in serviceList"
        :key="item.id"
        style="margin-top: 20px; min-height: 300px"
      >
        <img
          v-if="!item.imgsCode"
          style="width: 100%; height: 100px"
          src="@/assets/common/program.png"
          alt
        />
        <img
          v-else
          style="width: 100%; height: 100px"
          :src="item.imgsCode"
          alt
        />
        <h3
          style="
            margin: 0;
            font-size: 16px;
            line-height: 20px;
            min-height: 40px;
          "
        >
          {{ item.merchandiseName }}
        </h3>
        <p style="color: red; font-size: 16px; line-height: 20px">
          ￥{{ item.unitPrice }}
          <span>/{{ getUnit(item.unit) }}</span>
          <span v-if="item.serviceNumber">{{ item.serviceNumber }}次/月</span>
        </p>
        <p style="color: blue; font-size: 16px; line-height: 18px">
          提成比例{{ item.serviceFee }}%
        </p>
        <p
          style="
            height: 48px;
            line-height: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          "
        >
          {{ item.particulars }}
        </p>
        <div>
          <span v-if="item.isPutaway == true">上架</span>
          <span v-else>下架</span>
          <el-switch
            v-model="item.isPutaway"
            active-color="#13ce66"
            @change="changeOnOff(item)"
          ></el-switch>
        </div>
        <div style="display: flex; margin-top: 6px">
          <el-button
            size="mini"
            plain
            type="warning"
            @click="fixService(item)"
            >修改</el-button
          >
          <el-button
            size="mini"
            plain
            type="danger"
            @click="deletService(item)"
            >删除</el-button
          >
        </div>
      </el-col>
    </el-row>

    <!-- 新增服务弹窗 -->
    <el-dialog
      :title="isAddService ? '新增服务' : '修改服务'"
      width="660px"
      :visible.sync="serviceDialogVisible"
      :close-on-click-modal="false"
      @close="closeDialogService"
      top="8vh"
    >
      <el-form
        :model="dataForm"
        label-width="120px"
        :rules="dataFormRules"
        ref="dataForm"
        label-position="right"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="二级服务类别:" prop="secondLevellId">
              <el-select
                clearable
                v-model="dataForm.secondLevellId"
                placeholder="请选择"
                style="width: 100%"
                disabled
              >
                <el-option
                  v-for="item in secondLevellIdList"
                  :key="item.id"
                  :label="item.secondLevelName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="服务名称:" prop="merchandiseName">
              <el-input v-model.trim="dataForm.merchandiseName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="15">
            <el-form-item label="服务费用:" prop="unitPrice">
              <el-input-number
                v-model.trim="dataForm.unitPrice"
                :precision="2"
                style="width: 90%"
                controls-position="right"
                :min="0"
                :max="9999"
                placeholder="请输入服务费用"
              ></el-input-number>
              <span>元</span>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label label-width="0" prop="serviceNumber">
              <el-input-number
                @input.native="onInput0_100"
                onkeypress="return (/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                v-model.trim="dataForm.serviceNumber"
                style="width: 90%"
                controls-position="right"
                :min="0"
                :max="999"
                placeholder="请输入每月次数上限"
              ></el-input-number>
              <span>次</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="提成比例:" prop="serviceFee">
              <el-input v-model.trim="dataForm.serviceFee">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="上传图片:" prop="imgsCode">
              <el-upload
                class="avatar-uploader"
                action="string"
                accept="image/png, image/jpeg"
                :show-file-list="false"
                list-type="picture-card"
                :before-upload="beforeUpload"
                :http-request="upload"
              >
                <img
                  style="width: 100%; height: 100%"
                  v-if="dataForm.imgsCode"
                  :src="dataForm.imgsCode"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="服务介绍:" prop="particulars">
              <el-input
                type="textarea"
                v-model.trim="dataForm.particulars"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click.native="serviceDialogVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitServiceForm"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 新增商品弹窗 -->
    <el-dialog
      :title="isAddGood ? '新增商品' : '修改商品'"
      width="50%"
      :visible.sync="goodDialogVisible"
      :close-on-click-modal="false"
      @close="closeDialogGood"
      top="6vh"
      center
    >
      <el-form
        :model="dataForm"
        label-width="140px"
        :rules="dataFormRules"
        ref="dataForm"
        label-position="right"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="二级服务类别:" prop="secondLevellId">
              <el-select
                v-model="dataForm.secondLevellId"
                placeholder="请选择"
                clearable
                style="width: 100%"
                disabled
              >
                <el-option
                  v-for="item in secondLevellIdList"
                  :key="item.id"
                  :label="item.secondLevelName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品名称:" prop="merchandiseName">
              <el-input v-model.trim="dataForm.merchandiseName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="每月附送服务次数:" prop="serviceNumber">
              <el-input-number
                v-model.trim="dataForm.serviceNumber"
                :min="1"
                :precision="0"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品费用:" prop="unitPrice">
              <!--
                <el-input v-model.trim="dataForm.unitPrice" style="width:145px;">
                  <template slot="append">元</template>
                </el-input>
              -->
              <el-input-number
                v-model.trim="dataForm.unitPrice"
                :precision="2"
                style="width: 90%"
                controls-position="right"
                :min="1"
                :max="9999"
                placeholder="请输入商品费用"
              ></el-input-number>
              <span>元</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="提成比例:" prop="serviceFee">
              <el-input v-model.trim="dataForm.serviceFee">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位:" prop="unit">
              <el-select
                v-model="dataForm.unit"
                placeholder="请选择"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in unitList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="上传图片:" prop="imgsCode">
              <el-upload
                class="avatar-uploader"
                action="string"
                accept="image/png, image/jpeg"
                :show-file-list="false"
                list-type="picture-card"
                :before-upload="beforeUpload"
                :http-request="upload"
              >
                <img
                  style="width: 100%; height: 100%"
                  v-if="dataForm.imgsCode"
                  :src="dataForm.imgsCode"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品介绍:" prop="particulars">
              <el-input
                type="textarea"
                v-model.trim="dataForm.particulars"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click.native="goodDialogVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitGoodForm"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isAddService: true,
      isAddGood: true,
      serviceList: [],
      serviceDialogVisible: false,
      goodDialogVisible: false,
      second2LevellId: 0,
      dataForm: {
        // merchandiseName: "",
        // unitPrice: "",
        // serviceNumber: "",
        // serviceFee: "",
        // imgsCode: "",
        // particulars: "",
        unit: 0,
      },
      dataFormRules: {
        secondLevellId: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        unit: [{ required: true, message: "不能为空", trigger: "blur" }],
        merchandiseName: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 20, message: "长度在1到20个字符", trigger: "blur" },
        ],
        serviceNumber: [
          { required: true, message: "不能为空", trigger: "blur" },
          // {
          //   pattern: /^[1-9]\d*$/,
          //   message: "每月附送服务次数不能小于0"
          //   // trigger: "blur"
          // }
        ],
        unitPrice: [
          { required: true, message: "不能为空", trigger: "blur" },
          // {
          //     pattern: /^[1-9]\d*$/,
          //     message: "商品费用不能为0"
          //     // trigger: "blur"
          //   }
        ],
        serviceFee: [
          { required: true, message: "不能为空", trigger: "blur" },
          //   {
          //     // pattern: /^([1-9]?\d|100)$/,
          //     pattern: /^\d*(\.[1-9]|\.\d[1-9])*$/,
          //     message: "提成比例只能在0到100且不能超过小数点后两位",
          //     // trigger: "blur"
          //   },
          {
            pattern: /^([1-9]?\d|100)?$/,
            message: "提成比例只能在1到100且不能为小数",
            // trigger: "blur"
          },
        ],
        particulars: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 200, message: "长度在1到200个字符", trigger: "blur" },
        ],
      },
      id: "", //商品id
      unitList: [
        {
          label: "个",
          value: 0,
        },
        {
          label: "次/月",
          value: 1,
        },
        {
          label: "小时",
          value: 2,
        },
        {
          label: "张",
          value: 3,
        },
        {
          label: "件",
          value: 4,
        },
      ],
      secondLevellIdList: [], //二级类别菜单
      total: "",
    };
  },
  methods: {
    getSecondLevellIdList() {
      let params = {};
      this.$postJson("omc/serviceLevel/select", params).then((res) => {
        if (res.code == 200) {
          console.log(res.result, "111222111");
          res.result.forEach((item) => {
            if (item.firstLevelId == "230") {
              this.second2LevellId = item.id;
            }
          });
          this.secondLevellIdList = res.result;
          // this.second2LevellId =
          //   "" + this.secondLevellIdList[this.secondLevellIdList.length - 1].id;
        } else {
          this.secondLevellIdList = "";
        }
      });
    },
    //获取二级服务id
    getSecondLevellId() {
      let params = { groupId: sessionStorage.getItem("groupId") };
      this.$postJson("omc/service/listService", params).then((res) => {
        console.log(res.result);
        res.result.forEach((item) => {
          if (item.name == "远程看护") {
            item.serviceSecondLevelList.forEach((el) => {
              if (el.secondLevelName == "远程监测") {
                this.dataForm.secondLevellId = "" + el.id;
                this.getServiceList();
              }
            });
          }
        });
      });
    },

    onInput0_100(e) {
      this.$message.closeAll();
      // 验证是否是纯数字
      let isNumber = /^\d*$/.test(e.target.value);
      // 过滤非数字
      e.target.value = e.target.value.replace(/\D/g, "");
      if (!isNumber || e.target.value < 0 || e.target.value > 999) {
        this.$message.warning("只能输入[1,999]区间的整数");
      }
      e.target.value =
        (e.target.value >= 0 &&
          e.target.value <= 999 &&
          e.target.value.match(/^\d*/g)[0]) ||
        null;
    },

    //新增服务
    addService() {
      this.serviceDialogVisible = true;
      this.isAddService = true;
      this.getSecondLevellId();
      this.dataForm = {
        secondLevellId: this.second2LevellId,
        // merchandiseName: "",
        // unitPrice: "",
        // serviceNumber: "",
        // serviceFee: "",
        // imgsCode: "",
        // particulars: "",
        unit: 0,
      };
      console.log(this.secondLevellIdList);
      console.log(this.dataForm);
    },

    //新增商品
    addGood() {
      this.goodDialogVisible = true;
      this.isAddGood = true;
      this.getSecondLevellId();
      this.dataForm = {
        secondLevellId: this.second2LevellId,
      };
    },
    //提交服务数据

    submitServiceForm() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          if (this.isAddService) {
            let param = this.dataForm;
            param.serviceFee = Number(this.dataForm.serviceFee);
            this.$postJson(
              "omc/longRangeServiceOrder/addMerchandise",
              param
            ).then((res) => {
              if (res.code == 200) {
                this.serviceDialogVisible = false;
                this.getSecondLevellId();
                this.$message({ message: res.message, type: "success" });
                setTimeout(this.getServiceList(), 1000);
              } else {
                this.$message({ message: res.message, type: "error" });
              }
            });
          } else {
            let param = this.dataForm;
            param.id = this.id;
            this.$postJson("omc/merchandis/update", param).then((res) => {
              if (res.code == 200) {
                this.serviceDialogVisible = false;
                this.getSecondLevellId();
                this.$message({ message: res.message, type: "success" });
                setTimeout(this.getServiceList(), 1000);
              } else {
                this.$message({ message: res.message, type: "error" });
              }
            });
          }
        } else {
          return false;
        }
      });
    },

    //提交商品数据
    submitGoodForm() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          if (this.isAddGood) {
            let param = this.dataForm;
            param.serviceFee = Number(this.dataForm.serviceFee);
            this.$postJson(
              "omc/longRangeServiceOrder/addMerchandise",
              param
            ).then((res) => {
              if (res.code == 200) {
                this.goodDialogVisible = false;
                this.getSecondLevellId();
                this.$message({ message: res.message, type: "success" });
                setTimeout(this.getServiceList(), 1000);
              } else {
                this.$message({ message: res.message, type: "error" });
              }
            });
          } else {
            let param = this.dataForm;
            param.id = this.id;
            this.$postJson("omc/merchandis/update", param).then((res) => {
              if (res.code == 200) {
                this.goodDialogVisible = false;
                this.getSecondLevellId();
                this.$message({ message: res.message, type: "success" });
                setTimeout(this.getServiceList(), 1000);
              } else {
                this.$message({ message: res.message, type: "error" });
              }
            });
          }
        } else {
          return false;
        }
      });
    },

    //查询服务列表
    getServiceList() {
      let param = {
        pageNum: 1,
        pageSize: 999,
        // secondLevellId: this.dataForm.secondLevellId
      };
      this.$postJson("omc/merchandis/selectByBackstage", param).then((res) => {
        console.log(res);
        // this.serviceList = res.result.list.reverse();
        this.serviceList = res.result.list;
        this.total = res.result.total;
        this.serviceList.map((item) => {
          item.isPutaway == 0
            ? (item.isPutaway = true)
            : item.isPutaway == 1
            ? (item.isPutaway = false)
            : "";
          return item;
        });
      });
    },

    //删除服务数据
    deletService(row) {
      this.$confirm("是否删除该商品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.$postForm("omc/merchandis/delete", { id: row.id }).then((res) => {
          if (res.code == 200) {
            this.getSecondLevellId();
            this.getServiceList();
            this.$message({ type: "success", message: "删除成功!" });
          } else {
            this.$message({ type: "error", message: res.message });
          }
        });
      });
    },

    //修改服务数据
    fixService(row) {
      console.log(row);
      // if (row.serviceNumber != 0) {
      //   this.isAddService = false;
      //   this.serviceDialogVisible = true;
      // } else {
      //   this.isAddGood = false;
      //   this.goodDialogVisible = true;
      // }
      this.dataForm = JSON.parse(JSON.stringify(row));
      this.dataForm.unitPrice = String(row.unitPrice);
      console.log(this.dataForm);
      this.id = row.id;
    },

    //关闭弹窗
    closeDialogService() {
      this.$refs.dataForm.resetFields(); //移除校验结果并重置字段值
      this.dataForm = {};
    },

    closeDialogGood() {
      this.$refs.dataForm.resetFields(); //移除校验结果并重置字段值
      this.dataForm = {};
    },

    //上架下架
    changeOnOff(item) {
      console.log(item);
      if (item.isPutaway) {
        // let
        //上架
        this.$postJson("omc/merchandis/on", { merchandiseIds: [item.id] }).then(
          (res) => {
            if (res.code == 200) {
              this.$message({ message: "上架成功", type: "success" });
              this.getSecondLevellId();
            } else {
              this.$message({ message: res.message, type: "error" });
            }
          }
        );
      } else {
        //下架
        this.$postJson("omc/merchandis/off", {
          merchandiseIds: [item.id],
        }).then((res) => {
          if (res.code == 200) {
            this.$message({ message: "下架成功", type: "success" });
            this.getSecondLevellId();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        });
      }
    },
    /* 
      图片验证
    */
    beforeUpload(file) {
      console.log(file);
      if (file != undefined) {
        let isPNG = false;
        let isImage = false;
        file.type == "image/gif" ? (isPNG = false) : (isPNG = true);
        if (
          file.type == "image/bmp" ||
          file.type == "image/jpeg" ||
          file.type == "image/jpg" ||
          file.type == "image/png"
        ) {
          isImage = true;
        } else {
          isImage = false;
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isPNG) {
          this.$message.error("上传图片格式不能是 gif 格式");
        }
        if (!isImage) {
          this.$message.error("上传格式错误");
          return false;
        }
        if (!isLt2M) {
          this.$message.error("上传头像图片大小不能超过 2MB");
        }
        return isPNG && isLt2M && isImage;
      }
    },

    /* 
      上传图片
    */
    upload(param) {
      console.log(param);
      var fileObj = param.file;
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        console.log(form);
        this.$postFormData("opc/file/uploadFile", form).then((res) => {
          if (res.code == 200) {
            this.$postForm("opc/file/queryAttachmentById/" + res.result).then(
              (res) => {
                console.log(res);
                if (res.code == 200) {
                  this.dataForm.imgsCode =
                    "http://51cs8.com/" + res.result.path + res.result.name;
                }
              }
            );
          }
        });
      }
    },
    getUnit(unit) {
      this.unitList.forEach((item) => {
        if (unit == item.value) {
          unit = item.label;
        }
      });
      return unit;
    },
  },
  mounted() {
    this.getSecondLevellId();
    this.getSecondLevellIdList();
    this.getServiceList();
  },
};
</script>
<style lang="scss" scoped>
::deep .free .el-input {
  width: 25% !important;
}
::deep .free .el-input-group {
  width: 50% !important;
}
::deep .free .el-select {
  width: 25% !important;
}
::deep .free .el-select .el-input {
  width: 100% !important;
}
::deep .free .el-select,
.free .el-input {
  float: left;
}
// ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
</style>
